// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"hZM8s0XHSc","menuButtonIcon":"_3-CApSmquB"};